import { ProductDisplayList, myClassTabType } from '../../types/ui';

export const PRODUCT_LIST_DISPLAY = 'PRODUCT_LIST_DISPLAY';
export const OPEN_NAVBAR = 'OPEN_NAVBAR';
export const SAVE_LAST_SEEN_TAB = 'SAVE_LAST_SEEN_TAB';
export const OPEN_CLASSE_CHOICE = 'OPEN_CLASSE_CHOICE';

export const displayProductList = (productDisplay: ProductDisplayList) => ({
  type: PRODUCT_LIST_DISPLAY,
  payload: {
    productDisplay
  }
});
export const openNavBar = {
  type: OPEN_NAVBAR,
  payload: {
    navBarOpen: true
  }
};
export const closeNavBar = {
  type: OPEN_NAVBAR,
  payload: {
    navBarOpen: false
  }
};
export const saveLastSeenTab = (ClassTab: myClassTabType) => ({
  type: SAVE_LAST_SEEN_TAB,
  payload: {
    myClassTab: ClassTab
  }
});
export const openClasseChoice = {
  type: OPEN_CLASSE_CHOICE,
  payload: {
    classeChoiceOpen: true
  }
};
export const closeClasseChoice = {
  type: OPEN_CLASSE_CHOICE,
  payload: {
    classeChoiceOpen: false
  }
};

export type UiActions =
  | typeof openNavBar
  | typeof closeNavBar
  | typeof openClasseChoice
  | typeof closeClasseChoice
  | ReturnType<typeof saveLastSeenTab>
  | ReturnType<typeof displayProductList>;
